import React, { useCallback, useEffect, useState } from "react";
import { CalendarClock, ChevronRight } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { fmtSched } from "@/components/price/ScheduledRidesSheet";
import DriverScheduledSheet from "@/components/price/DriverScheduledSheet";

// Covoitureur : carte « Courses programmées » toujours visible + feuille classée par jour.
export default function DriverScheduledRequests() {
  const [data, setData] = useState({ open: [], mine: [], has_zone: true });
  const [busyId, setBusyId] = useState(null);
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("open");

  const load = useCallback(async () => {
    try {
      const r = await api.get("/price/ride-requests/scheduled");
      setData({ open: r.data?.open || [], mine: r.data?.mine || [], has_zone: r.data?.has_zone !== false });
    } catch (_e) { /* silencieux */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 20000);
    return () => clearInterval(t);
  }, [load]);

  const act = async (id, fn) => {
    setBusyId(id);
    try { await fn(); await load(); } catch (e) { toast.error(formatApiError(e)); } finally { setBusyId(null); }
  };
  const accept = (r) => act(r.id, async () => {
    const res = await api.post(`/price/ride-requests/${r.id}/accept`);
    toast.success(res.data?.request?.status === "scheduled_awaiting_payment"
      ? "Course acceptée — en attente du paiement du passager 💳"
      : "Course programmée acceptée ✅");
    setTab("mine");
  });
  const withdraw = (r) => act(r.id, async () => {
    if (!window.confirm("Te désister de cette course ? Elle sera reproposée aux autres covoitureurs.")) return;
    await api.post(`/price/ride-requests/${r.id}/cancel-by-driver`, { reason: "other", note: "Désistement course programmée" });
    toast("Course remise en ligne pour les autres covoitureurs");
  });

  const total = data.open.length + data.mine.length;
  const next = [...data.mine, ...data.open].sort((x, y) => (x.scheduled_at < y.scheduled_at ? -1 : 1))[0];
  return (
    <>
      <button
        type="button"
        onClick={() => { load(); setOpen(true); }}
        data-testid="driver-scheduled-card"
        className="street-press mt-5 flex w-full items-center gap-3 rounded-3xl bg-accent p-4 text-left text-accent-foreground street-border street-shadow"
      >
        <div className="relative grid h-12 w-12 flex-none place-items-center rounded-2xl bg-white street-border-thin rotate-[-4deg]">
          <CalendarClock className="h-6 w-6 text-primary" strokeWidth={2.5} />
          {data.open.length > 0 && (
            <span className="absolute -right-2 -top-2 grid h-6 min-w-6 place-items-center rounded-full bg-primary px-1 text-[11px] font-black text-primary-foreground street-border-thin" data-testid="driver-scheduled-count">
              {data.open.length}
            </span>
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="font-[Outfit] text-[17px] font-black leading-tight">Courses programmées</div>
          <div className="mt-0.5 text-[12px] font-semibold opacity-80" data-testid="driver-scheduled-summary">
            {total === 0 ? "Aucune pour l'instant — on te prévient dès qu'il y en a" : `${data.open.length} à prendre · ${data.mine.length} acceptée(s)`}
          </div>
          {next && <div className="truncate text-[11px] font-bold capitalize opacity-70">Prochaine : {fmtSched(next.scheduled_at)}</div>}
        </div>
        <ChevronRight className="h-5 w-5 flex-none" strokeWidth={3} />
      </button>
      {open && (
        <DriverScheduledSheet data={data} tab={tab} setTab={setTab} busyId={busyId}
          onAccept={accept} onWithdraw={withdraw} onReload={load} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
